import i18next from 'i18next';

i18next.addResources('es_CL', 'FeaturedOffers', {
  seeAll: 'Ver todas'
});

i18next.addResources('pt_PT', 'FeaturedOffers', {
  seeAll: 'Ver todas'
});
